import { AxiosSettingsAPI } from "../common/Api";
import { useQuery } from "react-query";

const ONE_HOUR = 60 * 60 * 1000;

export const useSettings = () => {
  return useQuery({
    queryKey: ["settings"],
    queryFn: async ({ signal }) => AxiosSettingsAPI.getAll({ signal }),
    staleTime: ONE_HOUR,
    cacheTime: 7 * 24 * ONE_HOUR,
    keepPreviousData: true,
    retry: 0,
    refetchOnWindowFocus: false,
    placeholderData: []
  });
};
